
















import { Component, Vue, Prop } from 'vue-property-decorator';
import URI from 'urijs';
import Hit from '@/components/Hit.vue';

@Component({
  components: { Hit },
  watch: {
    '$route': 'routeChanged',
  },
})
export default class ActiveAlerts extends Vue {
  private fetchNum: number = 0;
  private system: string = '';

  private total: number = 0;
  private hits: object[] = [];
  private loaded: boolean = false;

  public async fetch() {
    this.loaded = false;
    const url = new URI('https://alerts.zacharyseguin.ca/api/alerts/active');
    const count = 20;
    const fetchNum = ++this.fetchNum;

    url.setQuery('language', 'en-*');
    url.setQuery('status', 'actual');
    url.setQuery('sort', '-effective');
    url.setQuery('system', this.system || '');
    url.setQuery('count', count.toString());
    // tslint:disable-next-line:max-line-length
    url.setQuery('fields', 'system,headline,senderName,effective,expires,urgency,severity,certainty,responseTypes,areas.description');

    // Do initial request
    let response = await fetch(url.toString()).then((r) => r.json());
    if (this.fetchNum !== fetchNum) {
        return;
      }

    this.total = response.total;
    this.hits = response.hits;

    // Load remaining alerts
    for (let i = count; i < this.total; i += count) {
      url.setQuery('start', i.toString());
      response = await fetch(url.toString()).then((r) => r.json());

      if (this.fetchNum !== fetchNum) {
        return;
      }
      this.hits = this.hits.concat(response.hits);
    }

    this.loaded = true;
  }

  private routeChanged(n: any, old: any): void {
    if (n.meta.system && n.meta.system !== this.system) {
      this.system = n.meta.system;
      this.fetch();
    }
  }

  public mounted(): void {
    this.system = this.$route.meta.system;
    this.fetch();
  }
}
